import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const spendByLocationResponse = z.array(
  z.object({
    company_name: z.string(),
    revenue_date: z.string(),
    spend_category: z.string(),
    total_spend: z.number(),
  })
)

export type SpendByLocation = z.infer<typeof spendByLocationResponse>

export async function getSpendByLocation(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/spend_by_location', data, { signal })
    .then((response) => response.data)
    .then(spendByLocationResponse.parse)
}

export async function getSpendByLocationCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/cost/spend_by_location/csv', data, { signal })
    .then((response) => response.data)
}
